var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg pa-2 white",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"secondary--text"},[_vm._v(" موجودی ريالی انبار "),_c('v-spacer'),_c('chart-export-btn',{attrs:{"page-chart-id":"amount-inventory-chart"}})],1),_c('canvas',{attrs:{"height":"90","id":"amount-inventory-chart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }